export default "__VITE_ASSET__DAxMP3hd__"